export const INACTIVE_INDEX_VALUE = -1;

export const animationTimeout = 500;

export const ASSIGNMENTS_LABEL = 'Assignments';
export const BINDER_LABEL = 'Binder';
export const BROWSE_LABEL = 'Browse';
export const SEARCH_LABEL = 'Search';
export const YOUR_CONTENT_LABEL = 'Your Content';
